import createAction from '../services/create-action';
import uri from 'urijs';
import { buildPaginationRequestParams } from '../services/pagination';

export const FETCH_COMMENTS_REQUEST = 'comments/FETCH_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'comments/FETCH_SUCCESS';
export const FETCH_COMMENTS_FAILURE = 'comments/FETCH_FAILURE';

export const fetchCommentsRequest = createAction(FETCH_COMMENTS_REQUEST);
export const fetchCommentsSuccess = createAction(FETCH_COMMENTS_SUCCESS, payload => payload, (payload, meta) => meta);
export const fetchCommentsFailure = createAction(FETCH_COMMENTS_FAILURE);

export const fetchComments = ({ postId, postSlug, page, pageSize }) => {
  return (dispatch, getState, { request }) => {
    dispatch(fetchCommentsRequest({ postId, postSlug }));

    const params = buildPaginationRequestParams(page, pageSize);
    const promise = request(uri(`/_api/posts/${postId}/comments`).query(params), { parseHeaders: true });
    return promise
      .then(({ body = [], headers = {} }) => {
        const payload = {
          comments: body,
          postId,
          postSlug,
        };
        const meta = {
          page,
          entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10),
        };
        const action = fetchCommentsSuccess(payload, meta);
        return dispatch(action);
      })
      .catch(() => dispatch(fetchCommentsFailure({ postSlug })))
      .then(() => promise);
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-comments.js